import React, { useRef } from "react";
import { useNavigate } from "react-router-dom";

import banana1 from "../FeaturedProducts/banana1.png";
import banana2 from "../FeaturedProducts/banana2.png";
import banana3 from "../FeaturedProducts/banana3.png";
import tomato from "../FeaturedProducts/tomato.png";
import onion from "../FeaturedProducts/onion.png";

export default function RelatedProducts() {
  const scrollRef = useRef(null);
  const navigate = useNavigate();

  const products = [
    {
      name: "Cavendish banana powder",
      rating: "4.5",
      img: banana1,
      path: "/banana-powder",
    },
    {
      name: "Manzano banana powder",
      rating: "4.5",
      img: banana2,
      path: "/banana-powder",
    },
    {
      name: "Nendran banana powder",
      rating: "4.5",
      img: banana3,
      path: "/banana-powder",
    },
    {
      name: "Tomato Powder",
      rating: "4.5",
      img: tomato,
      path: "/tomato-powder",
    },
    {
      name: "Onion Powder",
      rating: "4.5",
      img: onion,
      path: "/onion-powder",
    },
  ];

  const slideRight = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollLeft += 260;
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <h3>Related Products</h3>
        <button
          type="button"
          style={styles.arrowBtn}
          onClick={slideRight}
        >
          →
        </button>
      </div>

      <div style={styles.slider} ref={scrollRef}>
        {products.map((item) => (
          <div key={item.name} style={styles.card}>
            <img src={item.img} alt={item.name} style={styles.img} />

            <p style={styles.name}>{item.name}</p>
            <p style={styles.rating}>⭐ {item.rating}</p>

            {/* ✅ WORKING NAVIGATION */}
            <button
              type="button"
              style={styles.moreBtn}
              onClick={() => navigate(item.path)}
            >
              Show more options
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}

const styles = {
  container: {
    marginTop: "40px",
    width: "100%",
  },

  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },

  arrowBtn: {
    background: "none",
    border: "none",
    fontSize: "22px",
    cursor: "pointer",
  },

  slider: {
    display: "flex",
    gap: "25px",
    overflowX: "auto",
    marginTop: "20px",
    paddingBottom: "10px",
    scrollBehavior: "smooth",
  },

  card: {
    minWidth: "250px",
    background: "#fff",
    padding: "20px",
    borderRadius: "12px",
    boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
    textAlign: "center",
    flexShrink: 0,
  },

  img: {
    width: "120px",
    height: "120px",
    objectFit: "contain",
    margin: "auto",
  },

  name: {
    fontWeight: "bold",
    marginTop: "10px",
  },

  rating: {
    color: "green",
    margin: "5px 0",
  },

  moreBtn: {
    background: "green",
    color: "white",
    padding: "8px 12px",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
    fontSize: "14px",
    marginTop: "8px",
  },
};
